module.exports = __webpack_public_path__ + "img/salmon_crudo_garnished.aba7f57d.jpg";